import React, { Component } from "react";
import { connect } from "react-redux";
import { nextScene } from "../../actions/sceneManager.js";
import { isMobile, initializeUser } from "../../actions/actionCreators.js";
import { manifest } from "./manifest.js";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		nextScene: next => dispatch(nextScene(next)),
		isMobile: () => dispatch(isMobile()),
		initializeUser: () => dispatch(initializeUser())
	};
};
class ManagerView extends Component {
	constructor(props) {
		super(props);
		this.state = { index: 0 };
		this.after = this.props.route.after;
	}
	componentWillMount() {
		this.props.isMobile();
		this.props.initializeUser();
		manifest.init.map(func => func());
		this.next();
	}
	next(index = 0) {
		if (index >= manifest.scenes.length) {
			this.props.router.push(this.after);
			manifest.exit.map(func => func());
		}else{
			this.props.nextScene({ index, ...manifest[index] });
			manifest.scenes[index].init.map(func => func());
			this.setState({ index });
		}
	}
	render() {
		const scene = manifest.scenes[this.state.index];
		const SceneComponent = scene.type;
		const nextScene = () => {
			manifest.scenes[this.state.index].exit.map(func => func());
			this.next(this.state.index + 1);
		}
		return <SceneComponent next={nextScene} {...scene.data} />;
	}
}

const SceneManager = connect(mapStateToProps, mapDispatchToProps)(ManagerView);
export default SceneManager;



// WEBPACK FOOTER //
// ./src/components/scenemanager/SceneManager.js